import { fetchAlerts } from "@utils/helpers"
import { InteractionRequiredAuthError, IPublicClientApplication } from "@azure/msal-browser";
import { AccountInfo } from "@azure/msal-common";
import { AlertState } from "@constants/Enums";
import { StandardTimeMap } from '@constants/const';



export const FetchFeatureSLIAlerts = async (serviceId: string, accounts: AccountInfo[], instance: IPublicClientApplication) => {

    let result = await fetchAlerts(accounts, instance, 1, 10, "", false, serviceId, [], [], "featureSLI");
    const SLIData = result.map((alert: IAlert) => {
        const SLIAction = alert.actions?.filter(action => alert.actions && alert.actions.some(action => action.hasOwnProperty('metricsQuery')))[0]
        console.log(SLIAction)
        return {
            key: alert.id,
            featureName: SLIAction.featureName,
            description: SLIAction.featureDescription,
            schedule: alert.standardTime? StandardTimeMap[alert.standardTime]:alert.cron,
            status: alert.alertState,
            alertLink: alert.id,
            alertName: alert.title,
            kustoCluster: SLIAction.kustoCluster.map(cluster => `https://${cluster.cluster}.${cluster.clusterSuffix}/${cluster.database}`),
            kustoTable: SLIAction.kustoTable,
            metrics: extractMetricsNames(SLIAction.metricsQuery),
        }
    })
    return SLIData;

};

const extractMetricsNames = (query: string): string[] => {
    const regex = /MetricsName\s*=\s*["']([^"']+)["']/g;
    const matches = [] as string[];
    let match;
    while ((match = regex.exec(query)) !== null) {
        matches.push(match[1]);
    }
    return matches;
};
